import {
  FLIGHT, HOTELS, BUSES, ROUTE_ICON_AND_TITLES, PACKAGES, AUTOS, MARRIOTT, BYHOURS, TOUR_AND_ACTIVITIES
} from '@app/constants/route-titles.constants';
import { ModuleEntity } from '@app/entities/modules-country';
import { byhoursHomeRootRoute, hotelsHomeRootRoute } from '@hotels/hotels-home/hotels-home-routing.module';
import { flightsRootRoute } from '@flights/flights-routing.module';
import { busesRootRoute } from '@buses/bus-home/bus-home-routing.module';
import { autoHomeRootRoute } from '@autos/auto-home/constants/routes';
import { HomeItemDetailWidgetType } from '@home-item-detail/entities/home-item-detail';
import { packagesHomeRootRoute } from '@packages/packages-home/constants/packages.routes';
import { RecentSearchDataType } from '@design-system/components/molecules/recent-search/entities/recent-search.types';
import { SearchType } from '@search-bar/entities/search-type';
import { homeItemDetailRootRoute } from '@home-item-detail/home-item-detail-routing.module';
import { activitiesHomeRootRoute } from '@activities/constants/activities.routes';
import { ChipActionBranding } from '@design-system/components/molecules/chip-action/entities/chip-action.types';
import { productHomeRoute } from '@app/constants/app-routing.constants';

const HOME_ROUTE = '/';

export const MODULES_ROUTING: { [key: string]: string[] } = {
  hotel: [hotelsHomeRootRoute, productHomeRoute],
  air: [flightsRootRoute, productHomeRoute],
  bus: [busesRootRoute, productHomeRoute],
  auto: [autoHomeRootRoute, productHomeRoute],
  package: [packagesHomeRootRoute, productHomeRoute],
  marriott: [homeItemDetailRootRoute, 'promo', 'marriott'],
  byhours: [byhoursHomeRootRoute, productHomeRoute],
  activities: [activitiesHomeRootRoute, productHomeRoute],
};

export const FLIGHTS_MODULE_ROUTE: string[] = [HOME_ROUTE, ...MODULES_ROUTING.air];
export const HOTELS_MODULE_ROUTE: string[] = [HOME_ROUTE, ...MODULES_ROUTING.hotel];
export const BYHOURS_MODULE_ROUTE: string[] = [HOME_ROUTE, ...MODULES_ROUTING.byhours];
export const BUSES_MODULE_ROUTE: string[] = [HOME_ROUTE, ...MODULES_ROUTING.bus];
export const AUTOS_MODULE_ROUTE: string[] = [HOME_ROUTE, ...(MODULES_ROUTING.auto)];
export const PACKAGES_MODULE_ROUTE: string[] = [HOME_ROUTE, ...(MODULES_ROUTING.package)];
export const MARRIOTT_ROUTE: string[] = [HOME_ROUTE, ...(MODULES_ROUTING.marriott)];
export const TOUR_AND_ACTIVITIES_MODULE_ROUTE: string[] = [HOME_ROUTE, ...MODULES_ROUTING.activities];

const FLIGHTS_PARENT_ROUTE: string = MODULES_ROUTING.air[0];
const HOTELS_PARENT_ROUTE: string = MODULES_ROUTING.hotel[0];
const BYHOURS_PARENT_ROUTE: string = MODULES_ROUTING.byhours[0];
const BUSES_PARENT_ROUTE: string = MODULES_ROUTING.bus[0];
const AUTOS_PARENT_ROUTE: string = MODULES_ROUTING.auto[0];
const PACKAGES_PARENT_ROUTE: string = MODULES_ROUTING.package[0];
const TOUR_AND_ACTIVITIES_ROUTE: string = MODULES_ROUTING.activities[0];

export const COUNTRY_MODULES_COLLECTION: ModuleEntity[] = [
  {
    name: FLIGHT,
    title: ROUTE_ICON_AND_TITLES[FLIGHT].TITLE,
    icon: ROUTE_ICON_AND_TITLES[FLIGHT].ICON,
    parentRoute: FLIGHTS_PARENT_ROUTE,
    route: FLIGHTS_MODULE_ROUTE,
    widget: HomeItemDetailWidgetType.Air,
    recent: RecentSearchDataType.Flight,
    searchType: SearchType.HOME_FLIGHT,
  },
  {
    name: HOTELS,
    title: ROUTE_ICON_AND_TITLES[HOTELS].TITLE,
    icon: ROUTE_ICON_AND_TITLES[HOTELS].ICON,
    parentRoute: HOTELS_PARENT_ROUTE,
    route: HOTELS_MODULE_ROUTE,
    widget: HomeItemDetailWidgetType.Hotel,
    recent: RecentSearchDataType.Hotel,
    searchType: SearchType.HOME_HOTELS
  },
  {
    name: BUSES,
    title: ROUTE_ICON_AND_TITLES[BUSES].TITLE,
    icon: ROUTE_ICON_AND_TITLES[BUSES].ICON,
    parentRoute: BUSES_PARENT_ROUTE,
    route: BUSES_MODULE_ROUTE,
    widget: HomeItemDetailWidgetType.Bus,
    recent: RecentSearchDataType.Bus,
    searchType: SearchType.HOME_BUSES
  },
  {
    name: AUTOS,
    title: ROUTE_ICON_AND_TITLES[AUTOS].TITLE,
    icon: ROUTE_ICON_AND_TITLES[AUTOS].ICON,
    parentRoute: AUTOS_PARENT_ROUTE,
    route: AUTOS_MODULE_ROUTE,
    widget: HomeItemDetailWidgetType.Auto,
    recent: RecentSearchDataType.Cars,
    searchType: SearchType.HOME_AUTOS
  },
  {
    name: PACKAGES,
    title: ROUTE_ICON_AND_TITLES[PACKAGES].TITLE,
    icon: ROUTE_ICON_AND_TITLES[PACKAGES].ICON,
    parentRoute: PACKAGES_PARENT_ROUTE,
    route: PACKAGES_MODULE_ROUTE,
    widget: HomeItemDetailWidgetType.Package,
    recent: RecentSearchDataType.Packages,
    searchType: SearchType.PACKAGES_HOME
  },
  {
    name: MARRIOTT,
    title: ROUTE_ICON_AND_TITLES[MARRIOTT].TITLE,
    icon: ROUTE_ICON_AND_TITLES[MARRIOTT].ICON,
    parentRoute: HOTELS_PARENT_ROUTE,
    route: MARRIOTT_ROUTE,
    widget: HomeItemDetailWidgetType.Marriott,
    recent: RecentSearchDataType.Hotel,
    searchType: SearchType.HOTELS_DETAIL,
    chipBranding: ChipActionBranding.Marriott,
    splitKey: 'HEADER_MODULE.HEADER_TABS.OFFICIAL_STORES',
  },
  {
    name: BYHOURS,
    title: ROUTE_ICON_AND_TITLES[BYHOURS].TITLE,
    icon: ROUTE_ICON_AND_TITLES[BYHOURS].ICON,
    parentRoute: BYHOURS_PARENT_ROUTE,
    route: BYHOURS_MODULE_ROUTE,
    widget: HomeItemDetailWidgetType.Byhours,
    recent: RecentSearchDataType.ByHours,
    searchType: SearchType.HOME_BYHOURS
  },
  {
    name: TOUR_AND_ACTIVITIES,
    title: ROUTE_ICON_AND_TITLES[TOUR_AND_ACTIVITIES].TITLE,
    icon: ROUTE_ICON_AND_TITLES[TOUR_AND_ACTIVITIES].ICON,
    parentRoute: TOUR_AND_ACTIVITIES_ROUTE,
    route: TOUR_AND_ACTIVITIES_MODULE_ROUTE,
    widget: HomeItemDetailWidgetType.Activities,
    recent: RecentSearchDataType.Activities,
    searchType: SearchType.TOUR_AND_ACTIVITIES,
    chipBranding: ChipActionBranding.Civitatis
  },
];
